import image from "../components/images/motaur.png"
export default function NotFound() {
    return (
    <div>
    <h3> 404 That's.....just not here.</h3>
    <img src={image} alt="Moutaur" width="800px" height="500px"/>
    </div>
    )   
}